export default __webpack_public_path__ + "locales/uk-UA/Common.json?hash=c39f42a55bee3629aac4a937672aac35";